// Solution for https://github.com/vuejs/vue/issues/9200
/* eslint-disable consistent-return */
const doubleRequestAnimationFrame = (callback) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback);
  });
};

const forceNextTick = (callback) => {
  if (callback && typeof callback === 'function') {
    doubleRequestAnimationFrame(callback);
  } else {
    return new Promise((resolve) => {
      doubleRequestAnimationFrame(resolve);
    });
  }
};
/* eslint-enable consistent-return */

const VueForceNextTick = {
  /**
   * Expose $forceNextTick to be used.
   *
   * @param {object} Vue
   */
  install(Vue) {
    /* eslint-disable no-param-reassign */
    Vue.$forceNextTick = forceNextTick;
    Vue.prototype.$forceNextTick = forceNextTick;
    /* eslint-enable no-param-reassign */
  },
};

export default VueForceNextTick;
